import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
} from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // 🔹 Import axios for API calls
import "../styles/ForgotPassword.css";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 🔹 Step state: 1 = email, 2 = OTP, 3 = reset password
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  // 🔹 Base URL for API (replace with your backend URL)
  const API_BASE_URL = process.env.REACT_APP_BASEURL || "http://localhost:4890";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (error) setError("");
    if (success) setSuccess("");
  };

  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [resendTimer]);

const validatePasswordForm = () => {
  if (!formData.newPassword || !formData.confirmPassword) {
    setError("Both password fields are required.");
    return false;
  }

  if (formData.newPassword !== formData.confirmPassword) {
    setError("Passwords do not match.");
    return false;
  }

  // 🔹 Align with backend: Password must be at least 8 characters (backend validation)
  if (formData.newPassword.length < 8) {
    setError("Password must be at least 8 characters.");
    return false;
  }

  // 🔹 Additional validation: must contain uppercase, lowercase, number, and special character
  if (
    formData.newPassword &&
    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(
      formData.newPassword
    )
  ) {
    setError(
      "Password must contain uppercase, lowercase, number and special character."
    );
    return false;
  }

  return true;
};


  const validateOtp = () => {
    if (!formData.otp) {
      setError("Please enter the OTP.");
      return false;
    }
    if (formData.otp.length !== 6) {
      setError("OTP must be 6 digits.");
      return false;
    }
    return true;
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email) {
      setError("Please enter your email.");
      return;
    }
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!formData.email) {
    setError("Please enter your email.");
    return;
  } else if (!emailRegex.test(formData.email)) {
    setError("Please enter a valid email address.");
    return;
  }
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/forgot-password-email`,
        {
          email: formData.email,
        }
      );
      setSuccess(
        response.data.message || "Password reset OTP sent successfully!"
      );
      setStep(2);
      setResendTimer(60); // ⬅️ start 10 min timer after first send
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to send OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    if (!validateOtp()) return;

    setLoading(true);
    try {
      // 🔹 API call to verify OTP
      const response = await axios.post(`${API_BASE_URL}/verify-otp`, {
        email: formData.email,
        otp: formData.otp,
      });
      setSuccess(response.data.message || "OTP verified successfully!");
      setStep(3); // Move to password reset step
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to verify OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!validatePasswordForm()) return;

    setLoading(true);
    try {
      // 🔹 API call to reset password
      const response = await axios.post(`${API_BASE_URL}/reset-password`, {
        email: formData.email,
        newPassword: formData.newPassword,
      });
      setSuccess(response.data.message || "Password changed successfully!");
      setTimeout(() => {
        navigate("/"); // Redirect to home
      }, 1500);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to change password. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = async () => {
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/forgot-password-email`,
        {
          email: formData.email,
        }
      );
      setSuccess(
        response.data.message || "A new OTP has been sent to your email!"
      );
      setResendTimer(600); // ⬅️ restart timer
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to resend OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container forgot-password-content-container">
          <section className="forgot-password-section">
            <Container>
              <h2 className="text-center forgot-password-heading mb-4">
                {step === 1
                  ? "Forgot Password"
                  : step === 2
                  ? "Enter OTP"
                  : "Reset Your Password"}
              </h2>

              {error && <Alert variant="danger">{error}</Alert>}
              {success && <Alert variant="success">{success}</Alert>}

              <Row className="justify-content-center">
                <Col lg={6} md={12}>
                  <Card className="p-4 shadow-sm forgot-password-card">
                    {step === 1 ? (
                      /* Step 1: Enter Email */
                      <Form onSubmit={handleEmailSubmit}>
                        <Form.Group controlId="email" className="mb-3">
                          <Form.Label className="form-label-forgot-password">
                            Email *
                          </Form.Label>
                          <Form.Control
                            type="email"
                            className="form-control-forgot-password"
                            name="email"
                            placeholder="Enter your email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            disabled={loading} // 🔹 Disable input during loading
                          />
                        </Form.Group>
                        <Row className="d-flex justify-content-center">
                          <Button
                            type="submit"
                            variant="primary"
                            className="w-auto"
                            disabled={loading}
                          >
                            {loading ? "Sending..." : "Submit"}
                          </Button>
                        </Row>
                      </Form>
                    ) : step === 2 ? (
                      /* Step 2: Enter OTP */
                      <Form onSubmit={handleOtpSubmit}>
                        <Form.Group controlId="otp" className="mb-3">
                          <Form.Label className="form-label-forgot-password">
                            OTP *
                          </Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control-forgot-password"
                            name="otp"
                            placeholder="Enter 6-digit OTP"
                            value={formData.otp}
                            onChange={handleChange}
                            maxLength={6}
                            required
                            disabled={loading}
                          />
                        </Form.Group>
                        <Row className="d-flex flex-column align-content-center gap-2">
                          <Button
                            type="submit"
                            variant="primary"
                            className="w-auto"
                            disabled={loading}
                          >
                            {loading ? "Verifying..." : "Verify OTP"}
                          </Button>
                          <Button
                            variant="primary"
                            className="w-auto"
                            disabled={resendTimer > 0 || loading}
                            onClick={handleResendOtp}
                          >
                            {resendTimer > 0
                              ? `Resend OTP in ${Math.floor(
                                  resendTimer / 60
                                )}:${String(resendTimer % 60).padStart(2, "0")}`
                              : "Resend OTP"}
                          </Button>
                        </Row>
                      </Form>
                    ) : (
                      /* Step 3: Enter New Password */
                      <Form onSubmit={handlePasswordSubmit}>
                        <Form.Group controlId="newPassword" className="mb-3">
                          <Form.Label className="form-label-forgot-password">
                            New Password *
                          </Form.Label>
                          <Form.Control
                            type="password"
                            className="form-control-forgot-password"
                            name="newPassword"
                            placeholder="Enter new password"
                            value={formData.newPassword}
                            onChange={handleChange}
                            required
                            disabled={loading} // 🔹 Disable input during loading
                          />
                        </Form.Group>

                        <Form.Group
                          controlId="confirmPassword"
                          className="mb-3"
                        >
                          <Form.Label className="form-label-forgot-password">
                            Confirm New Password *
                          </Form.Label>
                          <Form.Control
                            type="password"
                            className="form-control-forgot-password"
                            name="confirmPassword"
                            placeholder="Confirm new password"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                            disabled={loading} // 🔹 Disable input during loading
                          />
                        </Form.Group>
                        <Row className="d-flex justify-content-center">
                          <Button
                            type="submit"
                            variant="primary"
                            className="w-auto"
                            disabled={loading}
                          >
                            {loading ? "Changing..." : "Change Password"}
                          </Button>
                        </Row>
                      </Form>
                    )}
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
